<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <!-- <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"> -->
    <van-tabs v-model="active" @change="toggle" swipeable>
      <van-tab v-for="(item, index) in option" :title="item.title" :name="item.type" :key="index">
      </van-tab>
    </van-tabs>
    <template v-if="list.length">
      <van-panel v-for="(item, index) in list" style="margin-bottom:20px" :key="index">
        <template #header>
          <van-cell
            :title="item.subscribeContent + getPushType(item.pushType)"
            :icon="active == '1' ? 'notes-o' : 'user-o'"
          />
        </template>
        <template #footer>
          <div style="text-align:right">
            <van-button style="margin-right:10px" @click="edit(item)" size="small">编辑</van-button>
            <van-button size="small" @click="del(item, index)" type="danger">删除</van-button>
          </div>
        </template>
      </van-panel>
    </template>
    <van-empty v-else description="暂无信息" />
    <!-- </van-list> -->
  </van-pull-refresh>
</template>
<script>
import { getSubscribeInfo, rmSubsrcibeInfo } from '@/api/base';
export default {
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      active: '1',
      list: [],
      page: {
        size: 10,
        current: 1,
      },
      option: [
        { type: '1', title: '一尘新帖/成交帖' },
        { type: '2', title: '一尘卖家会员' },
      ],
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      getSubscribeInfo({ type: this.active }).then(res => {
        let tmpList = res.data || [];
        let list = this.list || [];
        if (this.refreshing) {
          list = tmpList;
          this.refreshing = false;
        } else if (tmpList.length) {
          list = [...list, ...tmpList];
        } else {
          this.finished = true;
        }
        this.loading = false;
        this.list = list;
        this.page.current++;
      });
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    toggle() {
      this.list = [];
      this.loading = true; //下拉加载中
      this.finished = false; //下拉结束
      if (this.loading) {
        this.onLoad();
      }
    },
    onRefresh() {
      this.refreshing = true;
      this.finished = false;
      this.onLoad();
    },
    edit(item) {
      item.isEdit = true;
      console.log(item);
      this.$router.push({ path: 'index', query: item });
    },
    del(item, index) {
      this.$dialog
        .confirm({
          title: '是否确认删除',
          message: '',
        })
        .then(() => {
          // on confirm
          rmSubsrcibeInfo(item.id).then(res => {
            this.list.splice(index, 1);
            this.$toast('删除成功');
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    getPushType(type) {
      let pushTypes = ['全部提醒', '只提醒求购帖', '只提醒出售帖', '只提醒成交帖'];
      return `  (${pushTypes[type]})`;
    },
  },
};
</script>
<style scoped>
.goods-card {
  margin: 0;
  background-color: #fff;
}

.delete-button {
  height: 100%;
}
</style>
